import { QUOTE_STATUSES } from '@/utils/constants';

/**
 * Returns fields for tagging quote statuses and defaults to empty values.
 *
 * @param status The quote status to get tag details
 * @returns {{color: undefined, label: undefined}|*}
 */
export default function getQuoteTagDetails(status) {
  if (!QUOTE_STATUSES[status]) {
    return {
      label: undefined,
      color: undefined
    };
  }
  return QUOTE_STATUSES[status];
}
